
define('text!libs/strand/src/shared/js/zousan.html',[],function () { return '<script src="../../../bower_components/zousan/zousan-min.js"></script>\n<script>\nZousan.suppressUncaughtRejectionError = true;\n</script>\n';});

